<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.go(-1)">返回</div>
      <span class="inline fr">支付</span>
    </div>
    <div class="content-box-sco">
      <p>
        服务价格：
        <el-radio-group v-model="radio">
          <el-radio v-if="order && order.service && order.service.price1 && order.service.price1 !== '0.00'"  :label="order.service.price1">{{order && order.service ? order.service.price1 + order.service.price1_mark : ''}}</el-radio>
          <!-- <el-radio v-if="order && order.service && order.service.price2 && order.service.price2 !== '0.00'" :label="order.service.price2">{{order && order.service ? order.service.price2 : ''}}</el-radio> -->
        </el-radio-group>
      </p>
      <p>
        <el-radio-group style="padding-left:68px;" v-model="radio">
          <!-- <el-radio v-if="order && order.service && order.service.price1 && order.service.price1 !== '0.00'"  :label="order.service.price1">{{order && order.service ? order.service.price1 : ''}}</el-radio> -->
          <el-radio v-if="order && order.service && order.service.price2 && order.service.price2 !== '0.00'" :label="order.service.price2">{{order && order.service ? order.service.price2 + order.service.price2_mark : ''}}</el-radio>
        </el-radio-group>
      </p>
      <p>订单编号：{{order && order.order_id ? order.order_id : ''}}</p>
      <p>设备编号：{{order && order.service && order.service.serial_num ? order.service.serial_num : ''}}</p>
      <p>设备名称：{{order && order.service && order.service.name ? order.service.name : ''}}</p>
      <!-- <p>联系人：{{order && order.patient_name ? order.patient_name : ''}}</p> -->
      <p>联系电话：{{order && order.patient_mobile ? order.patient_mobile : ''}}</p>
      <p>患者：{{order && order.patient_name ? order.patient_name : ''}}</p>
      <p>就诊医院：{{order && order.hospital_name ? order.hospital_name : ''}}</p>
      <p>就诊科室：{{order && order.depart_name ? order.depart_name : ''}}</p>
      <!-- <p>就诊医生:  {{order && order.doctor_name ? order.doctor_name : ''}}</p> -->
      <p v-if="order.invoice_type === 2">纳税人识别号：{{order && order.invoice_ident ? order.invoice_ident : ''}}</p>
      <p v-if="order.invoice_type === 2">纳税人地址：{{order && order.invoice_addr ? order.invoice_addr : ''}}</p>
      <p v-if="order.invoice_type === 2">纳税人电话：{{order && order.invoice_phone ? order.invoice_phone : ''}}</p>
      <p v-if="order.invoice_type === 2">开户银行：{{order && order.invoice_bank ? order.invoice_bank : ''}}</p>
      <p v-if="order.invoice_type === 2">银行账户：{{order && order.invoice_bank_account ? order.invoice_bank_account : ''}}</p>
      <p v-if="order.invoice_type !== 0">邮箱：{{order && order.invoice_mail ? order.invoice_mail : ''}}</p>
      <p v-if="order.invoice_type === 2">备注：{{order && order.comment ? order.comment : ''}}</p>
      <p v-if="order.invoice_type === 2">收票人手机：{{order && order.invoice_recv_phone ? order.invoice_recv_phone : ''}}</p>
      <!-- <p>客服电话：00000000</p> -->
      <el-row class="tc" style="margin-top: 10%">
        <el-button @click="$router.push({path: '/order', query: {device: $route.query.device, hospital: $route.query.hospital, orderId: order.order_id}})">修改订单</el-button>
        <el-button type="primary" @click="jumpPay">微信支付</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api'
export default {
  data () {
    return {
      radio: '',
      order: {}
    }
  },
  methods: {
    wpay () {
      // this.$router.push('accomplish')
    },
    jumpPay () {
      const orderId = this.$route.query.orderId
      // this.$router.push('accomplish/?orderId=' + orderId)
      const url = `/pages/wxpay/wxpay?ordercode=${orderId}&device=${this.$route.query.device}&token=${this.$cookies.get('h5_token')}&price=${this.radio}&hospital=${this.$route.query.hospital}`
      // 跳转到小程序支付界面wxPay
      wx.miniProgram.navigateTo({
        url: url
      })
    }
  },
  mounted () {
    if (this.$route.query.orderId) {
      var formData = new FormData()
      formData.append('token', this.$cookies.get('h5_token'))
      getInfo(this.$route.query.orderId, formData).then(res => {
        this.order = res.data
        this.radio = res.data.service.price2 === res.data.price && res.data.price !== '0.00' ? res.data.service.price2 : res.data.service.price1
        // this.form = {
        //   patient_mobile: res.data.patient_mobile,
        //   patient_name: res.data.patient_name,
        //   depart_name: res.data.depart_name,
        //   doctor_name: res.data.doctor_name,
        //   invoice_type: res.data.invoice_type,
        //   invoice_addr: res.data.invoice_addr,
        //   invoice_title: res.data.invoice_title
        // }
        // this.form.patient_mobile = res.data.patient_mobile
        // this.form.patient_name = res.data.patient_name
        // this.form.depart_name = res.data.invoice_title
        // this.form.doctor_name = res.data.doctor_name
        // this.form.invoice_addr = res.data.invoice_addr
        // this.form.invoice_title = res.data.invoice_title
        // this.form.hospital_name = res.data.hospital_name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-box-sco{
  padding: 0 5%;
  p{
    line-height: 40px;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pay.vue